import { gql } from "@apollo/client";

export const GET_STATION = gql`
  query Stations($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String) {
    station {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        stations {
          station_id
          name
          visual
          terminals,
          locationId: fk_locations
        }
        total
        offset
        limit
      }
    }
  }
`

export interface Station {
  station_id: number,
  name?: string,
  visual?: string,
  terminals: number[],
  locationId: number
}

export interface StationResponse {
  station: {
    info: {
      stations: Station[],
      total: number,
      offset: number,
      limit: number
    }
  }
}